(() => {
  const SWIPER_ATTR = 'data-fcv2-swiper-initialized';

  function getMaxSlidesForWidth(sectionEl) {
    const w = window.innerWidth || 0;
    if (w >= 1024) return parseInt(sectionEl.dataset.slidesDesktop || '4', 10) || 4;
    if (w >= 768) return parseInt(sectionEl.dataset.slidesTablet || '3', 10) || 3;
    return Math.max(1, Math.round(parseFloat(sectionEl.dataset.slidesMobile || '1.2')));
  }

  function syncSlideWidth(sectionEl, swiper) {
    const slidesMode = sectionEl.dataset.slidesMode || 'fixed';
    const baseSlideWidth = parseInt(sectionEl.dataset.autoSlideWidth || '280', 10) || 280;
    const gap = parseInt(sectionEl.dataset.spaceBetween || '20', 10);

    if (!swiper || !swiper.width) return;

    if (slidesMode !== 'fixed') {
      sectionEl.style.setProperty('--fcv2-slide-width', `${baseSlideWidth}px`);
      swiper.update();
      return;
    }

    const max = getMaxSlidesForWidth(sectionEl);
    const fit = Math.floor((swiper.width + gap) / (baseSlideWidth + gap));

    if (fit > max) {
      const fittedWidth = (swiper.width - gap * (max - 1)) / max;
      sectionEl.style.setProperty('--fcv2-slide-width', `${Math.floor(fittedWidth)}px`);
    } else {
      sectionEl.style.setProperty('--fcv2-slide-width', `${baseSlideWidth}px`);
    }

    swiper.update();
  }

  function initSwiperForPanel(sectionEl, panelEl) {
    const slider = panelEl.querySelector('[data-fcv2-swiper]');
    if (!slider || slider.hasAttribute(SWIPER_ATTR) || typeof window.Swiper === 'undefined') return;

    const spaceBetween = parseInt(sectionEl.dataset.spaceBetween || '20', 10);
    const prev = panelEl.querySelector('[data-fcv2-prev]');
    const next = panelEl.querySelector('[data-fcv2-next]');
    const navigation = prev && next ? { nextEl: next, prevEl: prev } : undefined;

    // eslint-disable-next-line no-new
    const swiper = new window.Swiper(slider, {
      slidesPerView: 'auto',
      spaceBetween,
      navigation,
    });

    slider.__fcv2Swiper = swiper;
    syncSlideWidth(sectionEl, swiper);

    slider.setAttribute(SWIPER_ATTR, 'true');
  }

  function showPanel(sectionEl, tabId) {
    const tabs = sectionEl.querySelectorAll('[data-fcv2-tab]');
    const panels = sectionEl.querySelectorAll('[data-fcv2-panel]');

    tabs.forEach((t) => {
      const active = t.getAttribute('data-fcv2-tab') === tabId;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    panels.forEach((p) => {
      const isMatch = p.getAttribute('data-fcv2-panel') === tabId;
      p.classList.toggle('is-hidden', !isMatch);
      if (isMatch) {
        initSwiperForPanel(sectionEl, p);
        const slider = p.querySelector('[data-fcv2-swiper]');
        if (slider && slider.__fcv2Swiper) {
          syncSlideWidth(sectionEl, slider.__fcv2Swiper);
        }
      }
    });
  }

  function initSection(sectionEl) {
    const tabs = sectionEl.querySelectorAll('[data-fcv2-tab]');
    const panels = sectionEl.querySelectorAll('[data-fcv2-panel]');
    if (!tabs.length || !panels.length) return;

    // Initialize first visible panel's swiper
    const firstPanel = Array.from(panels).find((p) => !p.classList.contains('is-hidden')) || panels[0];
    initSwiperForPanel(sectionEl, firstPanel);

    if (sectionEl.hasAttribute('data-fcv2-bound')) return;
    sectionEl.setAttribute('data-fcv2-bound', 'true');

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => showPanel(sectionEl, tab.getAttribute('data-fcv2-tab')));
    });

    if (!sectionEl.__fcv2ResizeBound) {
      sectionEl.__fcv2ResizeBound = true;
      window.addEventListener('resize', () => {
        const activePanel = sectionEl.querySelector('[data-fcv2-panel]:not(.is-hidden)');
        if (!activePanel) return;
        const slider = activePanel.querySelector('[data-fcv2-swiper]');
        if (slider && slider.__fcv2Swiper) {
          syncSlideWidth(sectionEl, slider.__fcv2Swiper);
        }
      });
    }
  }

  function initAll(root = document) {
    root.querySelectorAll('[data-featured-collection-v2]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (evt) => initAll(evt.target));
})();

